import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetAuthTokensQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetAuthTokensQuery = { __typename?: 'Query', getAuthTokens: { __typename?: 'SharedAuthTokens', accessToken?: string | null, refreshToken?: string | null } };


export const GetAuthTokens = /*#__PURE__*/ gql`
    query GetAuthTokens {
  getAuthTokens {
    accessToken
    refreshToken
  }
}
    ` as unknown as DocumentNode<GetAuthTokensQuery, GetAuthTokensQueryVariables>;

          

          export const useGetAuthTokensQuery = (options?:QueryHookOptions<GetAuthTokensQuery, GetAuthTokensQueryVariables>) => useQuery(GetAuthTokens, options);

          

          export type GetAuthTokensQueryOptions = QueryHookOptions<GetAuthTokensQuery, GetAuthTokensQueryVariables>;

          

          export const useGetAuthTokensLazyQuery = (options?:LazyQueryHookOptions<GetAuthTokensQuery, GetAuthTokensQueryVariables>) => useLazyQuery(GetAuthTokens, options);

          

          export type GetAuthTokensQueryResult = ReturnType<typeof useGetAuthTokensQuery>;

          
